<atx-search-input
  [isLoading]="isLoading"
  [noResult]="noResult"
  [formControl]="searchControl"
  [placeholderText]="placeholderText"
>
</atx-search-input>
